import { IconButton, Stack } from '@mui/material';
import { PaginationPages } from './PaginationPages';
import {
  changeUsersPage,
  useUsersPagination,
  useUsersRowsPerPage,
} from '../store';
import { useUsersCurrentPage, useUsersTotalCount } from '../hooks';

export const UsersPagination = () => {
  const state = useUsersPagination();
  const total = useUsersTotalCount();
  const page = useUsersCurrentPage();
  const rowsPerPage = useUsersRowsPerPage();

  const handleNextPage = () => {
    if (state.page < state.maxPage) {
      changeUsersPage(state.page + 1);
    }
  };

  const handlePreviousPage = () => {
    if (state.page > 1) {
      changeUsersPage(state.page - 1);
    }
  };

  return (
    <Stack direction="row" justifyContent="space-between" p={2}>
      <Stack direction="row" gap={0.5}>
        Showing
        <b>{`${page === 0 ? 1 : (page + 1) * rowsPerPage}-${total < rowsPerPage ? total : (page + 1) * rowsPerPage}`}</b>
        of <b>{total}</b>
      </Stack>
      <Stack direction="row" spacing={1}>
        <IconButton
          onClick={() => handlePreviousPage()}
          disabled={state.page > 1}
        >
          <svg
            width="8"
            height="15"
            viewBox="0 0 8 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7 13.5L1 7.5L7 1.5"
              stroke="black"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </IconButton>
        <PaginationPages />
        <IconButton onClick={() => handleNextPage()}>
          <svg
            width="8"
            height="15"
            viewBox="0 0 8 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 13.5L7 7.5L1 1.5"
              stroke={state.page === state.maxPage ? '#DDDDDD' : 'black'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </IconButton>
      </Stack>
    </Stack>
  );
};
